export default __webpack_public_path__ + "static/media/right-arrow.d18b6ab1.svg";